export default {
	apiBaseUrl: `${window.location.protocol}//${window.location.hostname}/cfc/api`,
};
